import { StorageScope } from "utilities/storageScope";

export default new StorageScope(":Dashboard");
